const func = ($target) => {
    window.loader.key('swiper', function () {
        var productsSlider = new Swiper($('.review-swiper-container'), {
            slidesPerView: 1,
            spaceBetween: 30,
            effect: 'slide',
            navigation: {
                nextEl: '.review-swiper-button-next',
                prevEl: '.review-swiper-button-prev'
            },
            breakpointsInverse: true,
            breakpoints: {
                768: {
                    slidesPerView: 1
                },
                992: {
                    slidesPerView: 2
                },
                1200: {
                    slidesPerView: 1
                }
            },
        });
    });

    var $inlineVideoPlay = $target.find('.inlineVideoPlay'),
        $videoTag = $target.find('video'),
        $iframe = $target.find('iframe'),
        src = $iframe.attr('src'),
        overlay = $target.find('.overlay-bg'),
        $playVideo = $target.find('.playVideo'),
        $videoModal = $target.find('.modal'),
        modalSrc = $videoModal.find('iframe').attr('src')
    $body = $('body');

    $videoTag.each(function () {
        $(this).removeAttr('controls')
    })

    $inlineVideoPlay.on('click', function () {
        var $iframe = $(this).parent().parent().find('iframe'),
            src = $iframe.attr('src');
        overlay.addClass('d-none')
        $playVideo.addClass('d-none')
        if ($iframe.length > 0) {
            src = src.replace('controls=0', 'controls=1');
            $iframe.attr('src', src)
            $iframe.attr('src', src + '&autoplay=1');
        } else {
            $(this).parent().parent().find('video').trigger('play').attr('controls', true);
        }
    })

    $videoModal
        .on('show.bs.modal', function (e) {
            var $iframe = $videoModal.find('iframe'),
                $video = $videoModal.find('video'),
                $modalName = $videoModal.data('name');

            if ($modalName == 'swiperVideoModal') {
                var outerSwiperModal = $(".swiperModal");
                $videoModal.appendTo(outerSwiperModal)
            }

            $body.addClass('modal-backdrop-media');
            if ($iframe.length > 0) {
                if (src.indexOf('?') == -1) {
                    $iframe.attr('src', modalSrc + '?autoplay=1');
                } else {
                    $iframe.attr('src', modalSrc + '&autoplay=1');
                }
            } else {
                $video.trigger('play');
            }
        })
        .on('hidden.bs.modal', function (e) {
            var $modalIframe = $videoModal.find('iframe'),
                $video = $videoModal.find('video');
            $('.swiperModal').html('')
            $body.removeClass('modal-backdrop-media');
            if ($modalIframe.length > 0) {
                $modalIframe.attr('src', '');
            } else {
                $video.trigger('pause');
            }
        });
}

export default func;
